import { Modal } from '@jouzen/ecom-components/v3/Modal';

import Video from '@/app/components/Video/Video';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const Gen3VideoModal = () => {
  const { or3VideoVisible, setOr3VideoVisible } = useSizingPageModalContext();
  const toggleModal = () => {
    setOr3VideoVisible(false);
  };

  return (
    <Modal
      isOpen={or3VideoVisible}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gen3-sizing-video-wrapper">
          <Video
            altImage={{
              src: 'sizing/alt_img_for_video',
              fill: true,
              alt: 'sizing_video_alt',
              format: 'png',
              sizes: '100vw',
            }}
            className="size-full"
            contentTitle="sizing_video"
            location="sizing-hero"
            playVideo={or3VideoVisible}
            src="sizing/sizing_video.mp4"
            type="video/mp4"
            posterSrc="sizing/video-poster-or3.png"
          />
        </div>
      </div>
    </Modal>
  );
};

export default Gen3VideoModal;
